import { Root, type VisuallyHiddenProps } from '@radix-ui/react-visually-hidden';

export type ConditionalVisuallyHiddenProps = VisuallyHiddenProps;

export default function ConditionalVisuallyHidden({
  hidden = true,
  children,
  ...props
}: ConditionalVisuallyHiddenProps) {
  if (hidden) {
    return <Root {...props}>{children}</Root>;
  }

  return <>{children}</>;
}
